export default __webpack_public_path__ + "static/media/img (3).d55690ba.jpg";